var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classNames+ '_text'},[(_vm.data.card_data)?_c('div',_vm._l((_vm.data.card_data),function(item){return _c('p',[_vm._v(" "+_vm._s(item.label)+":"+_vm._s(item.value)+" ")])}),0):_c('div',[_vm._v("你收到一条留资卡片消息，请打开抖音app查看")])])
}
var staticRenderFns = []

export { render, staticRenderFns }